/**
 * Action for show code view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.ShowcodeAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {Reservation} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var ShowcodeAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        self.plugin = plugin;

        // Parent plugin container
        self.pluginContainer = pluginContainer;

        // Main container of the action
        self.container = container;

        var reservationValues = JSON.parse(self.pluginContainer.querySelector('.values-json').innerHTML.trim());
        var modalTitle = document.getElementById('modal-reservation-code-title');
        if (reservationValues) {

            //Change headline of wizard from "new reservation" to "Voucher Nr:"
            modalTitle.querySelector('.reservation-id').innerHTML = reservationValues.reservationId;
        }
        modalTitle.classList.remove('d-none');

        document.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
            new Tooltip(tooltip);
        });


    };


    return ShowcodeAction;
})();
